"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _moment = _interopRequireDefault(require("moment"));
var _utils = require("@seedlang/utils");
var _root_model = _interopRequireDefault(require("./root_model"));
var _concept = _interopRequireDefault(require("./concept"));
var _deck = _interopRequireDefault(require("./deck"));
var _tree_node_concept = _interopRequireDefault(require("./tree_node_concept"));
var _tree_node_deck = _interopRequireDefault(require("./tree_node_deck"));
var _tree_node_grammar_concept = _interopRequireDefault(require("./tree_node_grammar_concept"));
var _image = _interopRequireDefault(require("./image"));
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _word_type = _interopRequireDefault(require("./word_type"));
var _level = _interopRequireDefault(require("./level"));
var _deck_rulebook = _interopRequireDefault(require("./deck_rulebook"));
var _user = _interopRequireDefault(require("./user"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var TreeNode = (_dec = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec2 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec3 = (0, _serializr.serializable)((0, _serializr.object)(_image["default"])), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.object)(_word_type["default"])), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_deck_rulebook["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_concept["default"]))), _dec8 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_deck["default"]))), _dec9 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_tree_node_concept["default"]))), _dec10 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_tree_node_grammar_concept["default"]))), _dec11 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_concept["default"]))), _dec12 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_tree_node_deck["default"]))), _dec13 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec14 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function TreeNode() {
    var _this;
    _classCallCheck(this, TreeNode);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TreeNode, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "position", _descriptor2, _this);
    _initializerDefineProperty(_this, "name", _descriptor3, _this);
    _initializerDefineProperty(_this, "shortName", _descriptor4, _this);
    _initializerDefineProperty(_this, "webPublished", _descriptor5, _this);
    _initializerDefineProperty(_this, "mobilePublished", _descriptor6, _this);
    _initializerDefineProperty(_this, "reviewed1", _descriptor7, _this);
    _initializerDefineProperty(_this, "reviewed2", _descriptor8, _this);
    _initializerDefineProperty(_this, "treeNodeId", _descriptor9, _this);
    _initializerDefineProperty(_this, "treeId", _descriptor10, _this);
    _initializerDefineProperty(_this, "note", _descriptor11, _this);
    _initializerDefineProperty(_this, "rating", _descriptor12, _this);
    _initializerDefineProperty(_this, "grammarTitle", _descriptor13, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor14, _this);
    _initializerDefineProperty(_this, "hasNote", _descriptor15, _this);
    _initializerDefineProperty(_this, "treePosition", _descriptor16, _this);
    _initializerDefineProperty(_this, "treeNodeDecksCount", _descriptor17, _this);
    _initializerDefineProperty(_this, "treeNodeConceptsCount", _descriptor18, _this);
    _initializerDefineProperty(_this, "treeModuleId", _descriptor19, _this);
    _initializerDefineProperty(_this, "treeRowId", _descriptor20, _this);
    _initializerDefineProperty(_this, "descriptionMd", _descriptor21, _this);
    _initializerDefineProperty(_this, "grammarDescriptionMd", _descriptor22, _this);
    _initializerDefineProperty(_this, "grammarDescription", _descriptor23, _this);
    _initializerDefineProperty(_this, "openAccess", _descriptor24, _this);
    _initializerDefineProperty(_this, "treeNodeType", _descriptor25, _this);
    _initializerDefineProperty(_this, "treeName", _descriptor26, _this);
    _initializerDefineProperty(_this, "publishedSentencesCount", _descriptor27, _this);
    _initializerDefineProperty(_this, "openAccessSentencesCount", _descriptor28, _this);
    _initializerDefineProperty(_this, "hasGrammarDescription", _descriptor29, _this);
    _initializerDefineProperty(_this, "lastWebTriviaPublishedAt", _descriptor30, _this);
    _initializerDefineProperty(_this, "lastMobileTriviaPublishedAt", _descriptor31, _this);
    _initializerDefineProperty(_this, "grammarTipsCount", _descriptor32, _this);
    _initializerDefineProperty(_this, "grammarDescriptionOverride", _descriptor33, _this);
    _initializerDefineProperty(_this, "webPublishedAt", _descriptor34, _this);
    _initializerDefineProperty(_this, "mobilePublishedAt", _descriptor35, _this);
    _initializerDefineProperty(_this, "image", _descriptor36, _this);
    _initializerDefineProperty(_this, "level", _descriptor37, _this);
    _initializerDefineProperty(_this, "wordType", _descriptor38, _this);
    _initializerDefineProperty(_this, "deckRulebook", _descriptor39, _this);
    _initializerDefineProperty(_this, "concepts", _descriptor40, _this);
    _initializerDefineProperty(_this, "decks", _descriptor41, _this);
    _initializerDefineProperty(_this, "treeNodeConcepts", _descriptor42, _this);
    _initializerDefineProperty(_this, "treeNodeGrammarConcepts", _descriptor43, _this);
    _initializerDefineProperty(_this, "grammarConcepts", _descriptor44, _this);
    _initializerDefineProperty(_this, "treeNodeDecks", _descriptor45, _this);
    _initializerDefineProperty(_this, "reviewed1User", _descriptor46, _this);
    _initializerDefineProperty(_this, "reviewed2User", _descriptor47, _this);
    return _this;
  }
  _inherits(TreeNode, _RootModel);
  return _createClass(TreeNode, [{
    key: "webPublishedInLastWeek",
    get: function get() {
      return (0, _utils.isPresent)(this.webPublishedAt) && (0, _moment["default"])(this.webPublishedAt.date).add(1, 'week') > new Date();
    }
  }, {
    key: "daysSinceLastTriviaUpdate",
    get: function get() {
      var dateObj = new _date_decorator["default"](this.lastWebTriviaPublishedAt);
      return dateObj.daysSince;
    }
  }, {
    key: "nameAndTreeNameAndDeckCount",
    get: function get() {
      return "".concat(this.name, " - ").concat(this.treeName, " - ").concat(this.treeNodeDecksCount, " decks");
    }
  }, {
    key: "allDecksHaveGrammarDescriptionOverride",
    get: function get() {
      return (0, _lodash.every)(this.treeNodeDecks.map(function (item) {
        var _item$deck;
        return (_item$deck = item.deck) === null || _item$deck === void 0 ? void 0 : _item$deck.grammarDescriptionOverride;
      }));
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "shortName", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "webPublished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "mobilePublished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "reviewed1", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "reviewed2", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "treeNodeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "treeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "note", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "rating", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "grammarTitle", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "hasNote", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "treePosition", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "treeNodeDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "treeNodeConceptsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "treeModuleId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "treeRowId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "descriptionMd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "grammarDescriptionMd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "grammarDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "openAccess", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "treeNodeType", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "treeName", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "publishedSentencesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "openAccessSentencesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "hasGrammarDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "lastWebTriviaPublishedAt", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "lastMobileTriviaPublishedAt", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "grammarTipsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "grammarDescriptionOverride", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "webPublishedAt", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "mobilePublishedAt", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "image", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "level", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "wordType", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "deckRulebook", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "concepts", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "decks", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "treeNodeConcepts", [_mobx.observable, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "treeNodeGrammarConcepts", [_mobx.observable, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "grammarConcepts", [_mobx.observable, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "treeNodeDecks", [_mobx.observable, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "reviewed1User", [_mobx.observable, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "reviewed2User", [_mobx.observable, _dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "webPublishedInLastWeek", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "webPublishedInLastWeek"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "daysSinceLastTriviaUpdate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "daysSinceLastTriviaUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nameAndTreeNameAndDeckCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nameAndTreeNameAndDeckCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allDecksHaveGrammarDescriptionOverride", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allDecksHaveGrammarDescriptionOverride"), _class.prototype), _class);
var _default = exports["default"] = TreeNode;